import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'external-system-data-privacy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './data-privacy.component.html',
  styleUrls: ['./data-privacy.component.scss'],
})
export class DataPrivacyComponent {}
